import React, { useState, useEffect, useRef } from "react";
import api from "services/api";
import { Collapse } from "react-bootstrap";
import { useHistory, Link } from "react-router-dom";
import Translator, { __ } from "services/Translator";

const SearchBox = (props) => {
  const history = useHistory();
  const [searchStr, setSearchStr] = useState("");
  const [searchSuggestions, setSearchSuggestions] = useState([]);

  const searchTextBox = useRef(null);

  const [expandSearchBar, setExpandSearchBar] = useState(false);

  const toggleExpandedSearchBar = (force) => {
    if (expandSearchBar) {
      setSearchSuggestions([]);
      if (force === true) {
        setSearchStr("");
        setExpandSearchBar(false);
      } else {
        if (searchStr.length === 0) {
          setExpandSearchBar(false);
        }
      }
    } else {
      setExpandSearchBar(true);
      searchTextBox.current.focus();
    }
  };

  const getSearchSuggestions = async () => {
    if (searchStr.length >= 2) {
      var response = await api.get("/games/search-suggestions", {
        query: searchStr,
        providers: props.selectedProviders,
        extensiveInfo: true,
      });
      console.log("getSearchSuggestions", response.data);
      if (response.status === 200) {
        setSearchSuggestions(response.data);
      }
    } else {
      setSearchSuggestions([]);
    }
  };

  useEffect(() => {
    getSearchSuggestions();
  }, [searchStr]);
  const doSearchByGameName = (text) => {
    setSearchStr("");
    props.setSearchStr(text);
    setSearchSuggestions([]);
    toggleExpandedSearchBar(true);
    history.push("/games/search");
  };
  return (
    <>
      <div className="searchbar_searchbox">
        <input
          className="form-control"
          id="searchFocusInput"
          placeholder={__("Search...")}
          autoComplete="off"
          value={searchStr}
          onChange={(ev) => setSearchStr(ev.target.value)}
          type="text"
          ref={searchTextBox}
        />
        {!props.leftSidebarSlide && (
          <span
            onClick={() => {
              props.setLeftSidebarSlide(true);
            }}
            className="search-icon position-absolute"
          >
            <i className="fas fa-search"></i>
          </span>
        )}
        {props.leftSidebarSlide && (
          <span className="search-icon position-absolute">
            <i className="fas fa-search"></i>
          </span>
        )}

        {!!searchSuggestions.length && (
          <div onClick={() => setSearchSuggestions([])} className="invisible_overlay"></div>
        )}

        <Collapse style={{ zIndex: 3050 }} in={!!searchSuggestions.length}>
          <div className="search_container">
            <div className="search_suggestions">
              <Link onClick={() => setSearchSuggestions([])} className="searchClose">
                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 50 50">
                  <path d="M 9.15625 6.3125 L 6.3125 9.15625 L 22.15625 25 L 6.21875 40.96875 L 9.03125 43.78125 L 25 27.84375 L 40.9375 43.78125 L 43.78125 40.9375 L 27.84375 25 L 43.6875 9.15625 L 40.84375 6.3125 L 25 22.15625 Z"></path>
                </svg>
              </Link>
              <ul>
                {searchSuggestions.map((item, index) => (
                  <li onClick={() => doSearchByGameName(item.game_name)} key={index}>
                    <img
                      alt={item.game_name}
                      src={item.game_snapshot_url}
                      onError={(event) => (event.target.parentElement.style.display = "none")}
                    />
                    {item.game_name}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </Collapse>
      </div>
    </>
  );
};
export default SearchBox;
